import React from "react";
import CommonControl from "./CommonControl";
import { useTranslation } from "react-i18next";

const Superintendent = (props) => {
  const { t } = useTranslation("form");

  return (
    <React.Fragment>
      <CommonControl {...props} keyName={'superintendent'} title={t("superintendent")} arr={['role','first_name_prefix','last_name','email','phone']} required={true} />
    </React.Fragment>
  );
};

export default Superintendent;